import styled from "styled-components";

const StyledDl = styled.dl`
  &&& {
    display: table;
    width: 100%;
    margin: 0;
    padding: 0;

    dt,
    dd {
      display: table-cell;
      font-size: 15px;
      height: 40px;
      vertical-align: middle;
      text-align: left;
      padding: 0 15px;
    }

    dt {
      width: 20%;
      background-color: #f9f9f9;
      font-weight: bold;
    }

    dd {
      width: 30%;
    }
  }
`;

const TimeDl = ({ className, children }) => {
  return <StyledDl className={className}>{children}</StyledDl>;
};

export default TimeDl;
